((HoverProductImage, $) => {
  'use strict';

  let $gridItem;

  const cacheDom = () => {
    $gridItem = $('.js-product-grid-item');
  };

  const bindUIActions = () => {
    $gridItem.on('mouseenter', function() {
      const $img = $(this).find('.img-main');
      const hasHoverImg = $img.attr('src-hover') || false;
      if(hasHoverImg){
        const hoverImgSrc = $img.attr('src-hover');
        $img.attr('src', hoverImgSrc);
      }
    });

    $gridItem.on('mouseleave', function() {
      const $img = $(this).find('.img-main');
      const mainImgSrc = $img.attr('src-main');
      $img.attr('src', mainImgSrc);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  HoverProductImage.init = init;
})(window.HoverProductImage = window.HoverProductImage || {}, jQuery);
